import * as agGrid from 'ag-grid-community';
import 'ion-rangeslider';
import Litepicker from 'litepicker';

async function init() {
  try {
    const data = await $.getJSON('/build/js/data.json');

    const myMap = new ymaps.Map('js-map', {
      center: [65.5, 86],
      zoom: 2,
      controls: ['smallMapDefaultSet'],
    }, {
      suppressMapOpenBlock: true,
      yandexMapAutoSwitch: false,
      yandexMapDisablePoiInteractivity: true,
      restrictMapArea: [
        [37, -19], [82, -154],
      ],
    });

    myMap.controls.remove('searchControl');

    const objectManager = new ymaps.ObjectManager({
      clusterize: true,
      gridSize: 80,
    });

    objectManager.add(data);
    myMap.geoObjects.add(objectManager);

    const filters = [
      {
        name: 'search',
        data: [],
        isActive: false,
        query(object) {
          return (this.data.includes(object.archive.owner_id)
            || this.data.includes(object.archive.name));
        },
      }, {
        name: 'region',
        data: [],
        isActive: false,
        query(object) {
          return this.data.includes(object.archive.region_id);
        },
      }, {
        name: 'survey',
        data: [],
        isActive: false,
        query(object) {
          return this.data.includes(object.archive.sphere_id);
        },
      }, {
        name: 'researchDateRange',
        data: [],
        isActive: false, // eslint-disable-next-line consistent-return
        query(object) {
          if (this.data[0] && this.data[1]) {
            return (object.archive.date_research >= this.data[0]
              && object.archive.date_research <= this.data[1]);
          }

          if (this.data[0] && !this.data[1]) {
            return object.archive.date_research >= this.data[0];
          }

          if (!this.data[0] && this.data[1]) {
            return object.archive.date_research <= this.data[1];
          }
        },
      }, {
        name: 'drillingDepth',
        data: [],
        isActive: false,
        query(object) {
          if (!this.data.length) {
            return true;
          }
          return object.archive.drill_depth >= this.data[0]
            && object.archive.drill_depth <= this.data[1];
        },
      },
    ];

    let visibleObjectsCount = objectManager.objects.getLength();
    const initialGridRows = objectManager.objects.getAll().map((item) => ({
      id: item.archive.id,
      name: item.archive.name,
      descr: item.archive.descr,
    }));

    const columnDefs = [
      {
        headerName: 'ID',
        field: 'id',
        minWidth: 80,
        maxWidth: 80,
      }, {
        headerName: 'Название',
        field: 'name',
        minWidth: 50,
        maxWidth: 150,
      }, {
        headerName: 'Описание',
        field: 'descr',
        minWidth: 50,
      },
    ];

    const gridOptions = {
      columnDefs,
      rowData: initialGridRows,
      defaultColDef: {
        flex: 1,
      },
      pagination: true,
      paginationPageSize: 10,
      domLayout: 'autoHeight',
      localeText: {
        page: 'Страница',
        more: 'ещё',
        to: '-',
        of: 'из',
        next: 'Следующая',
        last: 'Последняя',
        first: 'Первая',
        previous: 'Предыдущая',
        loadingOoo: 'Загрузка...',

        selectAll: 'Выбрать все',
        searchOoo: 'Поиск...',
        blanks: 'Пусто',

        filterOoo: 'Фильтровать...',
        applyFilter: 'Применить фильтр...',

        noRowsToShow: 'Архивных точек с заданным фильтром не найдено.'
          + ' Измените условия фильтра.',
      },
    };

    const eGridDiv = document.querySelector('#archive-points-grid');

    function initDataGrid() {
      // eslint-disable-next-line no-new
      new agGrid.Grid(eGridDiv, gridOptions);
    }

    function setFinalFilter() {
      visibleObjectsCount = 0;
      const visibleGridRows = [];
      const activeFilters = filters.filter((item) => item.isActive);
      let showCurrentObject = null;
      // eslint-disable-next-line max-len
      objectManager.setFilter((object) => {
        showCurrentObject = activeFilters.every((filter) => filter.query.call(filter, object));
        if (showCurrentObject) {
          visibleGridRows.push({
            id: object.archive.id,
            name: object.archive.name,
            descr: object.archive.descr,
          });
          visibleObjectsCount += 1;
        }
        return showCurrentObject;
      });
      gridOptions.api.setRowData(visibleGridRows);
      setStub(visibleObjectsCount);
    }

    function setStub(objects) {
      if (objects) {
        $('#archives-tab').removeClass('js-no-objects');
      } else {
        $('#archives-tab').addClass('js-no-objects');
      }
    }

    const wordForm = (num, word) => {
      const cases = [2, 0, 1, 1, 1, 2];
      return word[(num % 100 > 4 && num % 100 < 20) ? 2 : cases[(num % 10 < 5)
        ? num % 10
        : 5]];
    };

    function setTotalVisibleObjectsTxt() {
      const textFind = wordForm(visibleObjectsCount, [
        'Найдена', 'Найдено', 'Найдено',
      ]);
      const textAfter = wordForm(visibleObjectsCount, [
        'архивная точка', 'архивных точки', 'архивных точек',
      ]);
      const modifiedText = !visibleObjectsCount
        ? 'Архивных точек не найдено'
        : `${textFind} ${visibleObjectsCount} ${textAfter}`;

      $('.js-archive-total').text(modifiedText);
    }

    function initSearchAutocomplete() {
      const searchArr = [];

      data.features.filter((item) => {
        if (!searchArr.includes(item.archive.name)) {
          searchArr.push(item.archive.name);
        }

        if (!searchArr.includes(item.archive.owner_id)) {
          searchArr.push(item.archive.owner_id);
        }
      });

      const find = (arr, find) => arr.filter((value) => `${value}`.toLowerCase()
        .includes(find.toLowerCase()));

      const provider = {
        suggest(request, options) {
          const res = find(searchArr, request);
          const arrayResult = [];
          const results = Math.min(options.results, res.length);

          for (let i = 0; i < results; i++) {
            arrayResult.push({
              displayName: res[i],
              value: res[i],
            });
          }

          return ymaps.vow.resolve(arrayResult);
        },
      };

      const suggestView = new ymaps.SuggestView('js-suggest', {
        provider,
        results: 3,
      });

      suggestView.events.add('select', (item) => {
        filters.forEach((filter) => {
          if (filter.name === 'search') {
            if (filter.data.includes(item.get('item').value)) {
              return;
            }
            filter.data.push(item.get('item').value);
            filter.isActive = true;
            addFilterItem(filter.name, item.get('item').value);
          }
        });
        $('#js-suggest').val('');
        showFilters();
        setFinalFilter();
        setTotalVisibleObjectsTxt();
      });
    }

    function filterByRegion(e) {
      const regionName = e.target
        .closest('.js-location-item')
        .querySelector('.js-location-name').textContent;
      filters.forEach((filter) => {
        if (filter.name === 'region') {
          if (filter.data.includes(regionName)) {
            return;
          }
          filter.data.push(regionName);
          filter.isActive = true;
          addFilterItem(filter.name, regionName);
        }
      });

      setFinalFilter();
      showFilters();
      setTotalVisibleObjectsTxt();
    }

    function filterBySurvey(e) {
      const surveyName = e.target
        .closest('.js-survey-item')
        .querySelector('.js-survey-name').textContent;

      filters.forEach((filter) => {
        if (filter.name === 'survey') {
          if (filter.data.includes(surveyName)) {
            return;
          }
          filter.data.push(surveyName);
          filter.isActive = true;
          addFilterItem(filter.name, surveyName);
        }
      });

      showFilters();
      setFinalFilter();
      setTotalVisibleObjectsTxt();
    }

    const drillingDepthSliderOptions = {
      type: 'double',
      skin: 'square',
      hide_min_max: true,
      hide_from_to: true,
      input_values_separator: '-',
      step: 5,
      min: 0,
      max: 1000,
      from: 0,
      to: 1000,
      onChange(range) {
        $('.js-drilling-depth-slider-amount')
          .text(`${range.from_pretty} - ${range.to_pretty}`);
      },
      onFinish(range) {
        filters.forEach((filter) => {
          if (filter.name === 'drillingDepth') {
            filter.data[0] = range.from;
            filter.data[1] = range.to;
            filter.isActive = true;
            addFilterItem(filter.name, `${range.from_pretty} - ${range.to_pretty}`);
          }
        });

        showFilters();
        setFinalFilter();
        setTotalVisibleObjectsTxt();
      },
    };

    $('.js-drilling-depth-slider').ionRangeSlider(drillingDepthSliderOptions);

    const drillingDeptSliderInstance = $('.js-drilling-depth-slider')
      .data('ionRangeSlider');
    const initialFrom = drillingDeptSliderInstance.options.from;
    const initialTo = drillingDeptSliderInstance.options.to;

    $('.js-drilling-depth-slider-amount').text(`${initialFrom} - ${initialTo}`);

    let selectedFromDate = null;
    let cachedDate = null;

    // eslint-disable-next-line no-unused-vars
    const datepickerFrom = new Litepicker({
      element: document.getElementById('js-datepicker-from'),
      format: 'D-MM-YYYY',
      lang: 'ru-RU',
      onSelect() {
        selectedFromDate = this.getStartDate();
        const formattedDate = `${selectedFromDate.getFullYear()}-${`0${selectedFromDate.getMonth()
        + 1}`.slice(-2)}-${`0${selectedFromDate.getDate()}`.slice(-2)}`;

        filters.forEach((filter) => {
          if (filter.name === 'researchDateRange') {
            filter.data[0] = formattedDate;
            filter.isActive = true;
            addFilterItem(filter.name, formattedDate);
          }
        });

        showFilters();
        setFinalFilter();
        setTotalVisibleObjectsTxt();
      },
    });

    // eslint-disable-next-line no-unused-vars
    const datepickerTo = new Litepicker({
      element: document.getElementById('js-datepicker-to'),
      format: 'D-MM-YYYY',
      lang: 'ru-RU',
      onShow() {
        if (selectedFromDate === null || cachedDate === selectedFromDate) {
          return;
        }

        this.setOptions({
          minDate: selectedFromDate,
        });
        cachedDate = selectedFromDate;
      },
      onSelect() {
        const selectedToDate = this.getStartDate();
        const formattedDate = `${selectedToDate.getFullYear()}-${`0${selectedToDate.getMonth()
        + 1}`.slice(-2)}-${`0${selectedToDate.getDate()}`.slice(-2)}`;

        filters.forEach((filter) => {
          if (filter.name === 'researchDateRange') {
            filter.data[1] = formattedDate;
            filter.isActive = true;
            addFilterItem(filter.name, formattedDate);
          }
        });

        showFilters();
        setFinalFilter();
        setTotalVisibleObjectsTxt();
      },
    });

    function addFilterItem(filterName, filterValue) {
      if (!document.querySelector(`.${filterName}`) && filterName
        === 'researchDateRange') {
        filters.forEach((filter) => {
          if (filter.name === 'researchDateRange') {
            if (filter.data[0] && !filter.data[1]) {
              filterValue = `с ${filterValue}`;
            }

            if (!filter.data[0] && filter.data[1]) {
              filterValue = `по ${filterValue}`;
            }
          }
        });
      }

      const markup = `
      <div class="col-auto g-px-4 js-applied-filter-item ${filterName}">
        <div class="btn btn-outline-primary g-bg-white g-bg-primary--hover g-font-weight-600 g-font-size-13 g-cursor-default g-px-16 g-py-10 mb-2 d-flex">
          <span class="js-applied-filter-item-value">${filterValue}</span>
          <div class="js-reset-single-filter text-reset g-ml-5 g-cursor-pointer">
            <i class="fas fa-times"></i>
          </div>
        </div>
      </div>
      `;

      if (document.querySelector(`.${filterName}`) && filterName
        === 'drillingDepth') {
        document.querySelector(`.${filterName}`)
          .querySelector('.js-applied-filter-item-value').textContent = filterValue;
        return;
      }

      if (document.querySelector(`.${filterName}`) && filterName
        === 'researchDateRange') {
        // eslint-disable-next-line consistent-return,no-unused-vars
        filters.forEach((filter) => {
          if (filter.name === 'researchDateRange') {
            if (filter.data[0] && filter.data[1]) {
              document.querySelector(`.${filterName}`)
                .querySelector('.js-applied-filter-item-value').textContent = `с ${filter.data[0]} по ${filter.data[1]}`;
            } else if (filter.data[0] && !filter.data[1]) {
              document.querySelector(`.${filterName}`)
                .querySelector('.js-applied-filter-item-value').textContent = `с ${filter.data[0]}`;
            } else if (!filter.data[0] && filter.data[1]) {
              document.querySelector(`.${filterName}`)
                .querySelector('.js-applied-filter-item-value').textContent = `по ${filter.data[1]}`;
            }
          }
        });
        return;
      }

      $(document)
        .find('.js-applied-filters-list')
        .append(markup);
    }

    function showFilters() {
      $('.js-applied-filters-container').removeClass('d-none');
    }

    function hideFilters() {
      $('.js-applied-filters-container').addClass('d-none');
    }

    function resetSingleFilter(e) {
      const filterValue = $(e.target)
        .closest('.js-applied-filter-item')
        .find('.js-applied-filter-item-value')
        .text();
      const activeFilters = filters.filter((item) => item.isActive);

      activeFilters.forEach((activeFilter) => {
        if ($(e.target)
          .closest('.js-applied-filter-item')
          .hasClass(activeFilter.name)) {
          const indexOfFilter = activeFilter.data.indexOf(filterValue);

          if (activeFilter.name === 'drillingDepth') {
            activeFilter.data = [];
            drillingDeptSliderInstance.reset();
            $('.js-drilling-depth-slider-amount')
              .text(`${initialFrom} - ${initialTo}`);
          } else if (activeFilter.name === 'researchDateRange') {
            activeFilter.data = [];
            datepickerFrom.clearSelection();
            datepickerTo.clearSelection();
            datepickerTo.setOptions({
              minDate: null,
            });
            selectedFromDate = null;
            cachedDate = null;
          } else {
            activeFilter.data.splice(indexOfFilter, 1);
          }
          if (!activeFilter.data.length) {
            activeFilter.isActive = false;
          }
          $(e.target).closest('.js-applied-filter-item').remove();
        }
      });
      setFinalFilter();
      setTotalVisibleObjectsTxt();
      if (!(filters.filter((item) => item.isActive)).length) {
        hideFilters();
      }
    }

    function resetAllFilters() {
      // reset map
      objectManager.setFilter();
      // reset filters data
      filters.forEach((filter) => {
        filter.data = [];
        filter.isActive = false;
      });
      // reset range slider
      drillingDeptSliderInstance.reset();
      $('.js-drilling-depth-slider-amount')
        .text(`${initialFrom} - ${initialTo}`);
      // reset date picker
      datepickerFrom.clearSelection();
      datepickerTo.clearSelection();
      datepickerTo.setOptions({
        minDate: null,
      });
      selectedFromDate = null;
      cachedDate = null;

      $('.js-applied-filters-list')
        .find('.js-applied-filter-item')
        .remove();
      visibleObjectsCount = objectManager.objects.getLength();
      setStub(visibleObjectsCount);
      setTotalVisibleObjectsTxt();
      hideFilters();

      //  reset grid
      gridOptions.api.setRowData(initialGridRows);
    }

    initDataGrid();
    setTotalVisibleObjectsTxt();
    initSearchAutocomplete();
    $(document).on('click', '.js-location-item', filterByRegion);
    $(document).on('click', '.js-survey-item', filterBySurvey);
    $(document).on('click', '.js-reset-all-filters', resetAllFilters);
    $(document).on('click', '.js-reset-single-filter', resetSingleFilter);
  } catch (err) {
    console.log(new Error(err));
  }
}

export default init;
